import {Inline, Stack, VisuallyHidden} from '@treatwell/ui';
import {OrderDate} from './OrderDate';
import {useTranslation} from 'react-i18next';
import {useAppSelector} from '../../hooks/store';
import {formatTime} from '../../../shared/utils/formatTime';
import {
  selectSelectedDate,
  selectSelectedStartTime,
  selectSkusDuration,
} from '../../store/slices/selectors';
import {selectChannelData} from '../../store/slices/channel/slice';
import dayjs from 'dayjs';

export const OrderDateContainer = () => {
  const {locale} = useAppSelector(selectChannelData);
  const selectedDate = useAppSelector(selectSelectedDate);
  const formattedSelectedDate = dayjs(selectedDate).format('ddd DD MMM');
  const skusDuration = useAppSelector(selectSkusDuration);
  const selectedStartTime = useAppSelector(selectSelectedStartTime);
  const formattedSkusDuration = formatTime(skusDuration, locale);
  const {t} = useTranslation();

  const orderDate = {
    time: selectedStartTime,
    formattedDate: formattedSelectedDate,
    machineReadableDate: selectedDate,
    duration: formattedSkusDuration,
  };

  if (!orderDate.time) {
    return null;
  }

  return (
    <Stack space="base">
      <Inline justify="center">
        <VisuallyHidden as="h3">
          {t<string>('order.dateTimeTitle')}
        </VisuallyHidden>
        <OrderDate {...orderDate} time={orderDate.time} />
      </Inline>
    </Stack>
  );
};
